import { resolveDateBound } from "./dateRangeValidation";
import type { CompositeFieldDef } from "./compositeValidation";

export function getCompositeSubFieldDateBounds(
  field: CompositeFieldDef,
): { min?: string; max?: string } {
  const min = resolveDateBound(field.minDate);
  const max = resolveDateBound(field.maxDate);
  return {
    ...(min ? { min } : {}),
    ...(max ? { max } : {}),
  };
}

export function getCompositeSubFieldInputType(field: CompositeFieldDef): string {
  const type = String(field.type ?? "text").toLowerCase();
  if (type === "date") return "date";
  if (type === "number") return "number";
  if (field.format === "email") return "email";
  return "text";
}

export function inferCompositeSubFieldFormat(
  field: CompositeFieldDef,
): string | undefined {
  if (field.format) return String(field.format);
  if (/zip/i.test(String(field.key ?? ""))) return "us_zip";
  return undefined;
}
